/* eslint-disable */
// import {
//   Row,
//   Col,
//   Button,
//   Modal,
//   Breadcrumb,
//   Card,
//   Form,
// } from "react-bootstrap";
import DataTable from "react-data-table-component";
import React from "react";
import * as Icon from "react-bootstrap-icons";

import "../crmComponents/Contacts.css";

import { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router";

//Redux-imports
import { useDispatch, useSelector } from "react-redux";
import { addLeads } from "../../redux/actions/crmActions";
import Toast from "../assetLibComponents/shared/Toast";
import { ArrowRight } from "react-bootstrap-icons/dist";
//   import { addContact } from "../../../../../redux/actions/crmActions";

const AddLeads = (props) => {
  // const { pageFrom } = props;
  // const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [designation, setDesignation] = useState("");
  const [company, setCompany] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [customFieldArray, setCustomFieldArray] = useState([]);
  const [count, setCount] = useState(0);
  const [customFieldCount, setCustomFieldCount] = useState(0);

  // const contactDetails = useSelector((state) => state.crmLeads.contactDetails);

  // props.pageTypeHandler("CRM");

  const addTodo = () => {
    const newTodo = {
      self_id: count,
      label: "",
      placeholder: "",
      response_type: "",
      deleted: false,
    };

    const addPerfectTodo = [...customFieldArray, newTodo];

    addPerfectTodo.sort((a, b) => a.self_id - b.self_id);

    setCustomFieldArray(addPerfectTodo);
    setCustomFieldCount((prev) => prev + 1);
    setCount((prev) => prev + 1);
  };

  const handleLabelChange = (event, index) => {
    const newInputValues = [...customFieldArray];
    const newArr = newInputValues.map((obj) => {
      if (obj.self_id == index) {
        obj.label = event.target.value;
      }
      return obj;
    });
    setCustomFieldArray(newArr);
  };

  const handlePlaceholderChange = (event, index) => {
    const newInputValues = [...customFieldArray];
    const newArr = newInputValues.map((obj) => {
      if (obj.self_id == index) {
        obj.placeholder = event.target.value;
      }
      return obj;
    });
    setCustomFieldArray(newArr);
  };

  const handleTypeChange = (event, index) => {
    const newInputValues = [...customFieldArray];
    const newArr = newInputValues.map((obj) => {
      if (obj.self_id == index) {
        obj.response_type = event.target.value;
      }
      return obj;
    });
    setCustomFieldArray(newArr);
  };
  
  const removeQuestion = (id, type) => {
    const updatedArray = [...customFieldArray]
    const newArr = updatedArray.map((obj) => {
      if (obj.self_id === id) {
        obj.deleted = true;
        obj.self_id = obj.self_id + 100;
      } else if (obj.self_id > id) {
        obj.self_id = obj.self_id - 1;
      } else {
        obj.self_id = obj.self_id; 
      }
      return obj;
    });
    
    newArr.sort((a, b) => a.self_id - b.self_id);
    
    setCount((prev) => prev - 1);
    setCustomFieldArray(newArr);
    setCustomFieldCount((prev) => prev - 1)
  }

  const submitHandler = async (e) => {
    e.preventDefault();

    let newLead;

    newLead = {
      action: "add",
      name: fname,
      // lname: lname,
      company: company,
      company_website: companyWebsite,
      email: email,
      designation: designation,
      city: city,
      phone: phone,
    };

    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (fname === "") {
      Toast("Please Enter Name", "E");
    } else if (company === "") {
      Toast("Please Enter Company Name", "E");
    } else if (companyWebsite === "") {
      Toast("Please Enter Company Website", "E");
    } else if (phone === "") {
      Toast("Please Enter Mobile", "E");
    } else if (email === "" || regex.test(email) === false) {
      Toast("Please Enter Valid Email", "E");
    } else {
      dispatch(addLeads(props.authToken, newLead));
      navigate(-1);
    }
  };

  // useEffect(() => {
  //   if (contactDetails) {
  //     setFname(contactDetails.fname);
  //     setLname(contactDetails.lname);
  //     if(contactDetails?.company?.comapny_name){
  //       setCompany(contactDetails?.company?.company_name);
  //     }else{
  //       setCompany(contactDetails?.company);
  //     }

  //     setCompanyWebsite(contactDetails.company_web);
  //     setEmail(contactDetails.email);
  //     setDesignation(contactDetails.designation);
  //     setCity(contactDetails.city);
  //     setPhone(contactDetails.phone);
  //   }
  // }, []);

  return (
    <>
      <div className="new-contact mt-4 px-10">
        <div className="container">
          <div className="chat-ai-asset chatUrl">
            {/* Heading with Button */}
            <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
              <div className="text-lg leading-7 font-[500] my-auto">
                Custom Fields
              </div>
              <div className="flex">
                <div className="hover:bg-[#D1D5DB] hover:border-[rgba(83,85,86,0.1)] border border-[#D1D5DB] flex items-center gap-1.5 bg-transparent not-italic font-bold text-[14px] leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-3 mr-3">
                  <span>Save Changes</span>
                </div>
                <button
                  onClick={addTodo}
                  type="button"
                  className="ml-auto inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                >
                  + Add Fields
                </button>
              </div>
            </div>
            <div className="mt-4 mb-4">
              {/* <Form > */}
              <div className="flex flex-col">
                <div className="h-[65vh] overflow-y-auto listing pr-2">
                  {customFieldArray.length > 0 &&
                    customFieldArray.map((item, index) => {
                      return (
                        <>
                          {item.deleted !== true && <div className="flex h-[100px] justify-between mb-2 dragging-position">
                            <div className="bg-[#ffffff] relative rounded-md w-full p-3 shadow-sm ring-1 ring-inset ring-gray-200">
                              <span
                                htmlFor="name"
                                className="block text-xs mb-4 font-bold text-gray-800 pb-[5px] border-b-[#d7d3d3] border-b border-solid"
                              >
                                Custom Field {item.self_id + 1}
                              </span>
                              <div className="flex justify-between w-full]">
                                <div className="relative w-[32%]">
                                  <label
                                    htmlFor="name"
                                    className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-medium text-gray-900"
                                  >
                                    Label
                                  </label>
                                  <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                    value={item.label}
                                    onChange={(e) => {
                                      handleLabelChange(e, index);
                                    }}
                                  />
                                </div>
                                <div className="relative w-[32%]">
                                  <label
                                    htmlFor="name"
                                    className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-medium text-gray-900"
                                  >
                                    Placeholder Text
                                  </label>
                                  <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                    value={item.placeholder}
                                    onChange={(e) => {
                                      handlePlaceholderChange(e, index);
                                    }}
                                  />
                                </div>
                                <div className="relative w-[32%]">
                                  <label
                                    htmlFor="name"
                                    className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-medium text-gray-900"
                                  >
                                    Input Type
                                  </label>
                                  <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                    value={item.response_type}
                                    onChange={(e) => {
                                      handleTypeChange(e, index);
                                    }}
                                  />
                                </div>
                                <Icon.Trash className="absolute text-[15px] top-[8%] right-3.5 text-gray-600 cursor-pointer" onClick={()=>{removeQuestion(item.self_id, item.response_type)}} />
                              </div>
                            </div>
                          </div>}
                        </>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddLeads;
